import { FunctionComponent, memo } from "react";

import { IProps } from "./permission-summary.types";
import "./permission-summary.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { Tooltip } from "@edgetier/components";
import { PermissionDescription } from "constants/permissions";

/**
 * Summary details for permission
 * @param props.permission      Information about permission
 */
const PermissionSummary: FunctionComponent<IProps> = ({ permission }) => {
    return (
        <div className="permission-summary">
            <div className="permission-summary__title">{permission.permission}</div>
            {typeof PermissionDescription[permission.permissionId] === "string" &&
                PermissionDescription[permission.permissionId] !== "" && (
                    <Tooltip content={PermissionDescription[permission.permissionId]}>
                        <div className="permission-summary__description-info">
                            <FontAwesomeIcon icon={faInfoCircle} />
                        </div>
                    </Tooltip>
                )}
        </div>
    );
};

export default memo(PermissionSummary);
